import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectStats = ({ stats }) => {
  const statItems = [
    {
      icon: 'FileCode2',
      label: 'Total Files',
      value: stats?.totalFiles || 0,
      color: 'text-primary'
    },
    {
      icon: 'FolderTree',
      label: 'Folders',
      value: stats?.totalFolders || 0,
      color: 'text-accent'
    },
    {
      icon: 'HardDrive',
      label: 'Project Size',
      value: stats?.projectSize || '0 KB',
      color: 'text-warning'
    },
    {
      icon: 'Code2',
      label: 'Lines of Code',
      value: stats?.linesOfCode || 0,
      color: 'text-success'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {statItems?.map((item, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-3 md:p-4 hover:border-primary transition-colors"
        >
          <div className="flex items-center gap-3">
            <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-muted flex items-center justify-center ${item?.color}`}>
              <Icon name={item?.icon} size={20} />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-xs md:text-sm text-muted-foreground">{item?.label}</p>
              <p className="text-lg md:text-xl lg:text-2xl font-semibold mt-1 truncate">
                {typeof item?.value === 'number' ? item?.value?.toLocaleString() : item?.value}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProjectStats;